import { render, staticRenderFns } from "./SBSTasksWidget.vue?vue&type=template&id=5c8833da&scoped=true"
import script from "./SBSTasksWidget.vue?vue&type=script&lang=js"
export * from "./SBSTasksWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8833da",
  null
  
)

export default component.exports